























































import { Component, Prop, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'

@Component
export default class AccountHeader extends Vue {
  private accountData: any = []
  private headerText: string = ''
  private showDelete: boolean = false

  public getUserName (data: any) {
    this.accountData = data

    if (this.$route.params.user_id === null || this.$route.params.user_id === undefined) {
      this.headerText = '新規作成'
    } else {
      for (var i in this.accountData) {
        if (this.accountData[i].id.toString() === this.$route.params.user_id) {
          this.headerText = this.accountData[i].name
          this.showDelete = true
        }
      }
    }
  }

  private showDeleteModal () {
    this.$emit('show-delete-modal')
  }
}
